var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-container',[(_vm.loadingPage)?_c('v-row',{staticClass:"d-flex justify-center"},[_c('custom-loading')],1):_c('v-row',_vm._l((_vm.processGroups),function(processGroup,idx){return _c('autoservicio-group',{key:idx,attrs:{"id":'autoservicioListGroups' + idx,"processGroup":processGroup}})}),1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d592ccb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/groups/autoservicio-list-groups.vue
// module id = null
// module chunks = 